import type { FaireProductEntity } from "../../entity_types/product";

export const p_n2kkaxn53j: FaireProductEntity = {
  token: "p_n2kkaxn53j",
  type: "product",
  name: "Lavender Lemonade Single Serve Craft Cocktail",
  brandToken: "b_kxk5df5zt5",
  brandName: "Noble Mick's - Craft Beverage Company",
  imageUrl:
    "https://cdn.faire.com/fastly/01a2206d123a80444bc814d8abf3f401e9d049ef772e0b6b19501bda89aeec73.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/216ef9f4b73d1e649a1f47bc563683e9f4498474345cc148ecfcd54b5a0fdc29.jpeg",
    "https://cdn.faire.com/fastly/80907214d87818f9624e5976b0ac28b7ef1ada35bf1523762341dfdb15ecf0e9.png",
    "https://cdn.faire.com/fastly/d9a9cc5255f54accd5ee9d12e57082201c8ec28e681ddb7949c00139f0dbf26a.png",
  ],
  priceDollars: 1.5,
  description:
    "Lavender Lemonade Single Serve Craft Cocktail (or Mocktail) $1.50 each- Sold In quantities of 24 (Eligible For FREE Display Box Please Order Separately). \n\nNoble Mick's single serve craft cocktails are the perfect way to enjoy a craft cocktail anywhere, anytime.  At home or on the go there is no need to have all the ingredients to make your favorite cocktail.  \n\nNoble Mick's is NOT an infusion product these cocktails are ready to go when you are. Simply add H2O and Spirit, shake or stir with ice and enjoy. Never overly sweet or artificial tasting.  Seriously...our cocktails are delicious!\n\nAt Noble Mick's we use all natural fruit and vegetable powders, natural spices and flavors and pure cane sugar.  There is a real difference!\n\n- 100% All-Natural Ingredients\n- Easy Prep:  Simply add Water + Spirit\n- Shake, stir, or make right in the glass \n- No Artificial Flavors or Colors\n- Made in the USA 🇺🇸\n- Vegan & Gluten-Free \n- Makes 1 cocktail per packet\n- Proven High Sell-Through\n- Strong Reorder Rate – Customer Favorite\n- Super long shelf life\n- Light, flat and cheap to ship\n- Free displayers just add separately to order",
  tags: [],
  msrpDollars: 3,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T20:09:06.131Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
